import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignOutService } from '../../services/account/sign-out.service';
import { MainDataFactory } from '../../data/factory.mainDataFactory';
import { LoginService } from '../../services/account/login.service';
import { SecuritySettingsModel } from '../../models/security/security-settings.model';

@Component({
    selector: 'user-account',
    templateUrl: './user-account.component.html',
    providers: [LoginService, MainDataFactory]
})

export class UserAccountComponent implements OnInit {
    public userName: string = "Log In";
    public welcomeUser: string;
    constructor(private signOutService: SignOutService, private loginService: LoginService,
        private router: Router,
        private mainDataFactory: MainDataFactory) {
    }
    ngOnInit(): void {
        if (this.signOutService) { }
        this.loginService.getCurrentUser().subscribe((response) => {
            this.userName = response.userName.substring(0, 15) + '...';
            this.welcomeUser = 'Welcome, ' + response.userName;
        }, (error) => {
            if (error.status === 401) {
                //TODO: FIX THIS this.$rootScope.$broadcast(this.mainDataFactory.AppConfig.user_logged_in, { "user_logged_in": false });
                //this.$state.go('account.login');
                this.router.navigate(['account/login']);
            }

        });
        //this.menuOptions = { orientation: 'horizontal' };
    }
    /*
    public $onInit(): void {
        if (this.signOutService) { }
        //this.$state;
        this.loginService.getCurrentUser().then((response) => {
            this.userName = response.UserName;
            this.welcomeUser = 'Welcome, ' + response.UserName;
        }, (error) => {
            if (error.status === 401) {
                //TODO: FIX THIS this.$rootScope.$broadcast(this.mainDataFactory.AppConfig.user_logged_in, { "user_logged_in": false });
                //this.$state.go('account.login');
                this.router.navigate(['/account-login']);
            }

        });
        //this.menuOptions = { orientation: 'horizontal' };
    }*/

    public signOut() {
        //this.signOutService.signOut().then((response) => {
        //    this.userName = 'Log In';
        //    this.welcomeUser = 'Log In';
        //}, (error) => {
        //});
        this.mainDataFactory.AuthService.logout().then(() => {
            this.mainDataFactory.StorageService.clear(SecuritySettingsModel.access_token);
            this.userName = "Log In";
            this.router.navigate(['account/login']);
        });
    }

    public manage() {
        this.router.navigate(['/account/login']);
    }
}
